import Request from 'utilities/Request';
import {stringify} from 'querystring';

export const searchBuzz = (query, limit) => {
  const params = stringify({
    limit,
    terms: query,
    offset: 0,
  });
  return Request.get(`/api/search/v0/buzz/v4?${params}`);
};

export const searchUsersAndGroups = (query, limit) => {
  const params = stringify({
    filter: query,
    count: limit,
  });

  return Request.get(`/api/search/v0/users?${params}`);
};

export const searchCards = (query, limit) => {
  const params = stringify({
    filter: query,
    count: limit,
  });
  return Request.get(`/api/search/v0/kpis?${params}`);
};

export const searchEntities = (entityList, query, count, filters) => {
  const FACET_VALUE_LIMIT = 1000;
  const params = {
    count,
    entityList,
    offset: 0,
    query,
    filters,
    facetValueLimit: FACET_VALUE_LIMIT,
  };
  return Request.post(`/api/search/v1/query`, params);
};

export const searchTrack = (type, databaseId, queryUuid) => {
  const params = stringify({
    type,
    queryUuid,
    databaseId,
    queryProfile: 'GLOBAL',
  });
  return Request.post(`/api/search/v1/click?${params}`);
};
